module.exports = __webpack_public_path__ + "static/img/right-bottom-row-5.9f8d66ab.png";